(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-pills"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  // Handle View all toggle
  var link = e.target.closest('.housious-variant-viewall');

  if (link) {
    var group = link.closest('.housious-variant-pills');
    var total = group.querySelectorAll(
      '.housious-variant-pill[data-variant-id]'
    ).length;

    var expanded = group.classList.toggle('is-expanded');

    link.setAttribute('aria-expanded', expanded);
    link.querySelector('.viewall-text').textContent =
      expanded ? 'Show less' : 'View all (' + total + ')';

    return;
  }

  // Handle variant selection
  var pill = e.target.closest('.housious-variant-pill');
  if (!pill) return;

  var container = pill.closest('.product-variant-selector');
  if (!container) return;

  // Update selected pill state
  var allPills = container.querySelectorAll('.housious-variant-pill');

  allPills.forEach(function (p) {
    p.classList.remove('is-selected');
    p.setAttribute('aria-checked', 'false');
  });

  pill.classList.add('is-selected');
  pill.setAttribute('aria-checked', 'true');

  // Update selected variant title
  var titleDisplay = container.querySelector(
    '[data-selected-variant-title]'
  );

  if (titleDisplay) {
    titleDisplay.textContent =
      pill.getAttribute('data-variant-title');
  }

  // Reset quantity to 1 when variant changes
  var productSection = container.closest('.shopify-section');
  var quantityInput = null;

  if (productSection) {
    // Prefer the quantity input associated with this product form
    var productInfo = container.closest('product-info');
    var searchArea = productInfo || productSection;

    var productForm = searchArea.querySelector(
      'form[action*="/cart/add"]'
    );

    if (productForm) {
      quantityInput = productForm.querySelector(
        'input[name="quantity"], .quantity__input'
      );
    }

    // Fallback for themes with a different form structure
    if (!quantityInput) {
      var quantityWrapper = container.closest('.product');

      if (quantityWrapper) {
        quantityInput = quantityWrapper.querySelector(
          'input[name="quantity"], .quantity__input'
        );
      }
    }
  }

  if (quantityInput) {
    quantityInput.value = 1;

    // Notify theme scripts about the quantity change
    quantityInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    quantityInput.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
});
  } catch(e) { console.error(e); }
})();

})();
